import check from 'assets/svg/check.svg';

import color from 'atoms/colors/colors';
import { padding } from 'atoms/spacing/spacing';

export const menuProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
  style: {
    marginTop: padding[8],
  },
  getContentAnchorEl: null,
} as const;

const commonStyle = {
  MuiMenuItem: {
    styleOverrides: {
      root: {
        '&.Mui-selected:after': {
          backgroundImage: `url(${check})`,
          backgroundPosition: 'right center',
          backgroundRepeat: 'no-repeat',
          width: '24px',
          height: '24px',
          content: '""',
          marginLeft: 'auto',
        },
        '& > div': {
          whiteSpace: 'normal',
        },
      },
    },
  },
};

export const lightSelect = {
  MuiSelect: {
    styleOverrides: {
      root: {
        '&.Mui-focused .MuiSelect-select': {
          borderRadius: 8,
        },
        '& .MuiSelect-select': {
          height: 48,
          '& .MuiSelect-select': {
            padding: '8px 12px',
            '> div': {
              padding: '4px 0 5px',
            },
          },
        },
        '&&:hover fieldset': {
          borderColor: color.green[300],
        },
        '&& svg': {
          color: color.gray[900],
        },
        '&&.MuiInputBase-root': {
          maxHeight: 48,
          padding: 0,
          '&& fieldset': {
            borderWidth: 0,
          },
        },
      },
    },
  },
  ...commonStyle,
};

export const darkSelect = {
  MuiSelect: {
    styleOverrides: {
      root: {
        '& .MuiSelect-select': {
          height: 48,
          padding: '8px 12px',
          '> div': {
            padding: '4px 0 5px',
          },
        },
        '&.Mui-focused .MuiSelect-select': {
          borderRadius: 8,
        },
        '&&.MuiInputBase-root': {
          '&& fieldset': {
            borderWidth: 0,
            boxShadow: 'none',
          },
          '&& svg': {
            color: color.gray[900],
          },
          '&.Mui-error': {
            boxShadow: 'none',
          },
        },
      },
    },
  },
  ...commonStyle,
};
